import React, { useCallback, useMemo, useState } from 'react';
import { SIDEBAR_WIDTH_OPEN } from '@components/newNavigation/sidebar.constants';
import { LayoutContextType } from '@fabric-ui/components';

export const LayoutContext = React.createContext<LayoutContextType>({
  layoutWidths: { sideBar: SIDEBAR_WIDTH_OPEN },
  setLayoutWidths: () => {},
});

function LayoutContextProvider({ children }: React.PropsWithChildren = {}) {
  const [layoutWidths, setLayoutWidths] = useState(JSON.parse(localStorage.getItem('layoutWidths') || '{}'));

  const setWidths = useCallback((key, value) => {
    if (key === 'sideBar') {
      document.body.style.setProperty('--side-bar-width', `${value}px`);
    }
    setLayoutWidths(prev => {
      const newObj = { ...prev, [key]: value };
      localStorage.setItem('layoutWidths', JSON.stringify(newObj));
      return newObj;
    });
    setTimeout(() => dispatchEvent(new Event('resize')), 300);
  }, []);

  const value = useMemo(() => ({ layoutWidths, setLayoutWidths: setWidths }), [layoutWidths]);

  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export default LayoutContextProvider;

export const useLayoutContext = () => React.useContext(LayoutContext);
